<div class="host-house-order-guest" *ngIf="pageType === 'sidebar'">
  <nz-spin [nzSpinning]="loading">
    <div class="guests" *ngIf="guestList.length > 0">
      <div
        class="guest"
        *ngFor="let guest of guestList"
        (contextmenu)="checkedGuest = guest; onContextMenu($event, menu)"
      >
        <div class="header">
          <div class="guest-name">
            <span class="name">{{ guest?.name }}</span>
            <div *ngIf="guest?.gender === 1 || guest?.gender === 2">
              <img
                class="gender"
                [src]="
                  guest?.gender === 1
                    ? '/assets/guest/male.png'
                    : '/assets/guest/female.png'
                "
              />
            </div>
          </div>
          <i
            class="get-detail"
            nz-icon
            nzType="right"
            nzTheme="outline"
            (click)="checkGuestDetail(guest.id)"
          ></i>
        </div>

        <div class="labels" *ngIf="guest?.client_tags.length > 0">
          <div
            class="label"
            *ngFor="let label of guest?.client_tags"
            [style.background]="label?.color"
          >
            {{ label?.name }}
          </div>
        </div>
        <div class="guest-info">
          <div class="guest-item" *ngIf="showItem(guest?.phone)">
            <div class="title">
              <!-- 手机： -->
              {{ 'order.phone' | translate }}
            </div>
            <div class="content">{{ guest?.phone }}
              <span style="color: #666; margin-left: 10px">{{ guest?.phone_area }}</span></div>
          </div>
          <div class="guest-item" *ngIf="showItem(guest?.email)">
            <div class="title">
              <!-- 邮箱： -->
              {{ 'order.email' | translate }}
            </div>
            <div class="content">{{ guest?.email }}</div>
          </div>
          <div class="guest-item" *ngIf="showItem(guest?.id_number)">
            <div class="title">
              <!-- 证件： -->
              {{ 'order.certificate' | translate }}
            </div>
            <div class="content">
              <span>{{ guest?.idType }} {{ guest?.id_number }}</span>
              <span
                class="pics"
                (click)="showCredentials(guest?.client_credential)"
                *ngIf="guest?.client_credential?.length > 0"
              >
                <img src="/assets/icon/attachment.png" />
                <span class="number">{{
                  guest?.client_credential?.length
                }}</span>
              </span>
            </div>
          </div>
          <div
            class="guest-item"
            *ngIf="showItem(guest?.consumer_info?.last_checkin_time)"
          >
            <div class="title">
              <!-- 上次入住： -->
              {{ 'order.last_checkin' | translate }}
            </div>
            <div class="content">
              <span>
                {{
                  guest?.consumer_info?.last_checkin_time | dateformat: ['YMD']
                }}
              </span>
              <span style="padding-left: 5px">
                ({{
                  (guest?.consumer_info?.checkin_times === 1
                    ? 'order.checkin_times_single'
                    : 'order.checkin_times_repeatedly'
                  ) | translate: { i: guest?.consumer_info?.checkin_times }
                }})
              </span>
            </div>
          </div>
          <div
            class="guest-item"
            *ngIf="guest?.consumer_info?.cumulative_consumer !== 0"
          >
            <div class="title">
              <!-- 累计消费： -->
              {{ 'order.cumulative_consumption' | translate }}
            </div>
            <div class="content">
              <span>{{ guest?.consumer_info?.currency_type }}</span>
              <span style="padding-left: 5px">{{
                guest?.consumer_info?.cumulative_consumer
              }}</span>
            </div>
          </div>
        </div>

        <div
          class="similar"
          *ngIf="guest?.has_similar"
          (click)="checkSimilarGuest(guest?.id)"
        >
          <span>
            <!-- 部分信息与其他房客重复 -->
            {{ 'order.similar_to_other_guest' | translate }} >
          </span>
        </div>
      </div>
    </div>
    <div class="none" *ngIf="guestList.length === 0">
      <img class="host-no-data-img-large" src="/assets/icon/no_data.png" />
      <div class="title">
        <!-- 暂无房客 -->
        {{ 'order.no_guest' | translate }}
      </div>
    </div>
  </nz-spin>

  <div class="footer">
    <button nz-button (click)="closePannel()">
      {{ 'word.close' | translate }}
    </button>
    <button nz-button (click)="addGuest()">
      <!-- 添加房客 -->
      {{ 'order.add_guest' | translate }}
    </button>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="deleteGuest(checkedGuest?.id)">
      <!-- 从列表中移除 -->
      {{ 'order.remove_guest_in_list' | translate }}
    </li>
    <li nz-menu-item (click)="editGuest(checkedGuest)">
      <!-- 修改 -->
      {{ 'word.modify' | translate }}
    </li>
  </ul>
</nz-dropdown-menu>

<div class="host-house-order-guest" *ngIf="pageType === 'modal'">
  <div class="table-wrapper">
    <host-table-fixed-header
      [showArrow]="true"
      [nzData]="guestList"
      [nzLoading]="loading"
      [headerList]="listOfHeader"
      [headerTotalWidth]="2550"
      [nzShowPagination]="false"
      [tableInModal]="true"
    >
      <tbody class="table-body">
        <tr *ngFor="let data of guestList">
          <td [style.width]="listOfHeader[0].width">
            <div class="name">
              <span>{{ data?.name }}</span>
              <div *ngIf="data?.gender === 1 || data?.gender === 2">
                <img
                  class="gender"
                  [src]="
                    data?.gender === 1
                      ? '/assets/guest/male.png'
                      : '/assets/guest/female.png'
                  "
                />
              </div>
            </div>
          </td>
          <td [style.width]="listOfHeader[1].width">
            {{ data?.phone ? data?.phone : '-' }}
          </td>
          <td [style.width]="listOfHeader[2].width">
            {{ data?.email === '' ? '-' : data?.email ? data.email : '-' }}
          </td>
          <td [style.width]="listOfHeader[3].width">
            <div class="credentials">
              <span class="type">{{ getIdType(data?.id_type) }}</span>
              <div
                class="pics"
                (click)="showCredentials(data?.client_credential)"
                *ngIf="data?.client_credential?.length > 0"
              >
                <img src="/assets/icon/attachment.png" />
                <span class="number">{{
                  data?.client_credential?.length
                }}</span>
              </div>
            </div>
          </td>
          <td [style.width]="listOfHeader[4].width">
            {{ data?.id_number ? data?.id_number : '-' }}
          </td>
          <td [style.width]="listOfHeader[5].width">
            {{ data?.consumer_info?.cumulative_consumer }}
          </td>
          <td [style.width]="listOfHeader[6].width">
            {{ data?.consumer_info?.checkin_times }}
          </td>
          <td [style.width]="listOfHeader[7].width">
            {{ data?.consumer_info?.avg_reservation_price }}
          </td>
          <td [style.width]="listOfHeader[8].width">
            {{ data?.consumer_info?.total_nights }}
          </td>
          <td [style.width]="listOfHeader[9].width">
            {{ data?.consumer_info?.avg_night_price }}
          </td>
          <td [style.width]="listOfHeader[10].width">
            {{
              data?.consumer_info?.last_checkin_time
                ? (data?.consumer_info?.last_checkin_time | dateformat: ['YMD'])
                : '-'
            }}
          </td>
          <td [style.width]="listOfHeader[11].width">
            {{
              data?.consumer_info?.first_checkin_time
                ? (data?.consumer_info?.first_checkin_time
                  | dateformat: ['YMD'])
                : '-'
            }}
          </td>
          <td [style.width]="listOfHeader[12].width">
            {{ getCountryName(data?.country) }}
          </td>
          <td [style.width]="listOfHeader[13].width">
            {{ data?.birthday ? (data?.birthday | dateformat: ['YMD']) : '-' }}
          </td>
          <td [style.width]="listOfHeader[14].width">
            {{
              data?.client_comment?.comment
                ? data?.client_comment?.comment
                : '-'
            }}
          </td>
          <td [style.width]="listOfHeader[15].width">
            {{ data?.client_tags.length === 0 ? '-' : data?.tags }}
          </td>
          <td [style.width]="listOfHeader[16].width">
            <span class="operate" (click)="editGuest(data)">
              <!-- 编辑 -->
              {{ 'word.edit' | translate }}
            </span>
            <span class="operate" (click)="deleteGuest(data?.id)">
              <!-- 删除 -->
              {{ 'word.delete' | translate }}
            </span>
          </td>
        </tr>
      </tbody>
    </host-table-fixed-header>
  </div>
</div>
